import { useState } from "react";
import { useAsync } from "react-async";
import { getMyTeam } from "../../../../api/services/therapistService";
import { DashboardProps, DashboardPropsDefaults } from "../../types/dashboardProps.d";
import Spinner from "../../../spinner";
import { useHistory } from "react-router-dom";
import District from "../../../../api/models/district";

const fetchMyTeam = async ({ id }: any) => await getMyTeam(id)

const DashboardWidgetTherapistMyTeam = ({ user }: DashboardProps): JSX.Element => {
    const [districts, setDistricts] = useState<District[]>([]);
    const id: number = user.userId!;
    const history = useHistory();

    //Get the user's caseload
    const asyncUsers = useAsync({
        promiseFn: fetchMyTeam, id,
        onResolve: (response) => setDistricts(response.data)
    });

    return (
        <div className={DashboardPropsDefaults.containerClassNames}>
            <div className="pb-1 dashboard-widget-title">
                <h3>My Team</h3>
            </div>
            <div className={DashboardPropsDefaults.contentClassNames}>
                <Spinner show={asyncUsers.isPending} />
                {districts.length > 0 && <>
                    {districts.map((district, di) => <div key={`my-team-district-${district.districtId}`} className={`my-team-district-${district.districtId}`}>
                        {district.schools.length > 0 && <>
                            <h3 className={`my-team-district-${district.districtId} text-sm font-bold`}>{district.name}
                                <span
                                    className="ml-2 text-xs font-normal underline cursor-pointer hover:no-underline"
                                    onClick={() => history.push(`admin/districts/${district.districtId}/calendar`, { districtName: district.name })}
                                >District Calendar</span>
                            </h3>
                            {district.schools.map((school, i) => {
                                return school.users && school.users.length > 0 ? <div key={`my-team-district-${district.districtId}-school-${school.schoolId}-${i}`}>
                                    <h3 className={`my-team-district-${district.districtId}-school-${school.schoolId} text-sm font-semibold`}>{school.name}</h3>
                                    <ul className="mb-4 list-none">
                                        {school.users?.map((user, j) => (
                                            <li key={`my-team-school${i}-${user.userId}`} className="pl-5 my-0.5 text-xs">
                                                <span className="font-xs">{user.lastName}, {user.firstName} - <a className="font-xs" href={`mailto:${(user.secondaryEmailAddress == undefined || user.secondaryEmailAddress == null || user.secondaryEmailAddress == '') ? user.emailAddress : user.secondaryEmailAddress}`}>{(user.secondaryEmailAddress == undefined || user.secondaryEmailAddress == null || user.secondaryEmailAddress == '') ? user.emailAddress : user.secondaryEmailAddress}</a></span>
                                            </li>
                                        ))}
                                    </ul>
                                </div> : <></>
                            })}
                        </>}
                    </div>)}
                </>}
                {districts.length === 0 && !asyncUsers.isPending && <h3>No schools with therapists found</h3>}
            </div>
        </div>
    );
};

export default DashboardWidgetTherapistMyTeam;
